module.exports = __webpack_public_path__ + "static/taylor.af166ee5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/commercial_logos/taylor.png
// module id = 2174
// module chunks = 61762850755587